import { MarketingCampaign } from "../../entities/marketing-campaign.model";

export class MarketingCampaignForm {
	campaigns: MarketingCampaign[] = [];

	constructor(data?: MarketingCampaign[]) {
		if (data) {
			this.campaigns = data.map((item) => ({
				name: item.name,
				paused: item.paused,
			}));
		}
	}
}
